// extracted by mini-css-extract-plugin
export default {"ViewData":"styles_ViewData__9PIGV","col":"styles_col__SW2Mf","switchContainer":"styles_switchContainer__n+8Yr","fullWidth":"styles_fullWidth__EFccw"};